import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'absolute inset-0',
    center:
      'absolute flex w-full flex-col gap-2 max-lg:inset-x-0 max-lg:bottom-8 max-lg:container lg:top-1/2 lg:left-1/2 lg:size-0',
    item: 'max-lg:w-full lg:absolute',
    wrap: 'flex w-full items-center justify-end gap-4 rounded-full p-2 backdrop-blur-[20px] max-lg:pl-5 sm:p-3',
    content: 'max-lg:w-full max-lg:text-left',
    title: 'sm:heading-m-bold heading-s-bold',
    description: 'mt-2 max-lg:hidden',
    mobileDescription: 'mt-2 px-5 pb-5 lg:hidden',
    ellipse:
      'flex-center m:size-16 size-12 shrink-0 rounded-full border-1 border-white bg-[linear-gradient(243.49deg,rgba(212,221,229,0.6)_-21.99%,rgba(255,255,255,0)_116.55%)] backdrop-blur-[7px] sm:backdrop-blur-[20px] lg:size-21 lg:border-2',
    ellipseInner:
      'flex-center size-10 rounded-full bg-white sm:size-12 lg:size-18',
    icon: ''
  },
  variants: {
    mode: {
      pink: {
        title: 'text-brand-bioderma',
        icon: 'text-brand-bioderma',
        wrap: 'bg-white/50',
        description: 'heading-xs-bold',
        mobileDescription: 'heading-xs-bold sm:heading-s-bold'
      },
      dark: {
        item: 'text-white',
        icon: 'text-blue',
        wrap: 'bg-white/30',
        description: 'heading-xs-bold',
        mobileDescription: 'heading-xs-bold sm:heading-s-bold'
      },
      light: {
        title: 'text-brand-bioderma',
        icon: 'text-blue',
        wrap: 'bg-white/50',
        description: 'heading-xs',
        mobileDescription: 'heading-xs sm:heading-s'
      }
    },
    index: {
      0: {
        item: '',
        content: 'text-right'
      },
      1: {
        wrap: 'lg:flex-row-reverse',
        content: 'text-left'
      },
      2: {
        item: '',
        content: 'text-right'
      }
    }
  },
  compoundVariants: [
    // dark
    {
      mode: 'pink',
      index: 0,
      className: {
        item: 'right-15 -bottom-8 w-[453px]',
        content: 'w-[280px] text-right'
      }
    },
    {
      mode: 'pink',
      index: 1,
      className: {
        item: 'top-4 left-11 w-[453px]',
        content: 'w-[313px] text-left'
      }
    },
    {
      mode: 'pink',
      index: 2,
      className: {
        item: 'top-46 right-15 w-[412px]',
        content: 'w-[260px] text-right'
      }
    },
    // pink
    {
      mode: 'dark',
      index: 0,
      className: {
        item: 'right-7 -bottom-4 w-[460px]',
        content: 'w-[306px]'
      }
    },
    {
      mode: 'dark',
      index: 1,
      className: {
        item: '-top-5 left-10 w-[460px]',
        content: 'w-[315px]'
      }
    },
    {
      mode: 'dark',
      index: 2,
      className: {
        item: 'top-18 right-7 w-[360px]',
        content: 'w-[206px]'
      }
    },
    // light
    {
      mode: 'light',
      index: 0,
      className: {
        item: 'right-28 -bottom-8 w-[393px]',
        content: 'w-[239px]'
      }
    },
    {
      mode: 'light',
      index: 1,
      className: {
        item: '-top-20 left-6 w-[564px]',
        content: 'w-[410px]'
      }
    },
    {
      mode: 'light',
      index: 2,
      className: {
        item: 'top-28 right-7 w-[420px]',
        content: 'w-[270px]'
      }
    }
  ]
});
